// 配置的尺寸
export const derives = ['960*540', '540*960', '640*360', '360*640']

// 配置的字号
export const fonts = [6, 7, 8, 10, 12, 13, 14, 16, 18, 20, 25, 28, 36, 48, 72]
